import { render, staticRenderFns } from "./response-template-list.vue?vue&type=template&id=f294aa06&"
import script from "./response-template-list.vue?vue&type=script&lang=js&"
export * from "./response-template-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports